/* @flow */

import React from 'react';
import { Dropdown } from 'semantic-ui-react';

type Props = {
  value?: number,
  folders: List<BucketFolder>,
  onChange: (folder: number) => void,
};

const mapFoldersToOptions = (folders: List<BucketFolder>) =>
  folders
    .map(f => ({
      value: f.id,
      text: f.name,
    }))
    .toArray();

const FoldersFilter = ({ value, folders, onChange }: Props) => {
  const changeFolder = (_, { value }) => onChange(value);

  return (
    <Dropdown
      value={value}
      selection
      placeholder="Dossier"
      options={mapFoldersToOptions(folders)}
      onChange={changeFolder}
    />
  );
};

export default FoldersFilter;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/components/FoldersFilter.js